// extracted by mini-css-extract-plugin
export default {"root":"Progress_root__ayady","bar":"Progress_bar__1Kz5h","process":"Progress_process__BrFPD","animate":"Progress_animate__7iO++"};